import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";
import { LONG_WRITE_TIMEOUT_MS } from "@/utils/axios-client";
import {
  OrderSheetProduct,
  OrderSheetStatus,
} from "@/features/order-sheets/order-sheet.type";

export interface SubmitOrderSheetSetV2Request {
  orderSheetIds?: number[];
  orderSheetTabs?: {
    index: number;
    products: OrderSheetProduct[];
  }[];
  // 협의된 추가 오더 — 최소주문금액 미달이어도 서버가 받는다(제출 알림에 추가 오더로 표시된다).
  isAdditionalOrder?: boolean;
}

export interface SubmitOrderSheetSetV2Response {
  revisionNumber: number;
  orderSheetSet: {
    status: OrderSheetStatus;
  };
}

export interface SubmitOrderSheetSetV2sPathParameter {
  buyerId: number;
  orderSheetSetId: number;
}

export const submitOrderSheetSetKey: YWRKey<SubmitOrderSheetSetV2sPathParameter> =
  {
    url: (parameter) => {
      const { buyerId, orderSheetSetId } = parameter;
      return `/buyers/${buyerId}/order-sheet-sets/${orderSheetSetId}/submit-v2`;
    },
    method: "post",
  };

export default function useSubmitOrderSheetSetV2() {
  const fetcher = useFetcher<
    SubmitOrderSheetSetV2Request,
    SubmitOrderSheetSetV2Response
  >();

  // 제출은 서버가 전 탭을 검증·확정하느라 30초를 넘길 수 있다 — 기본 타임아웃(30초)에 잘리지 않게.
  return useYWR(submitOrderSheetSetKey, fetcher, {
    timeout: LONG_WRITE_TIMEOUT_MS,
  });
}
